import { useId } from 'react';
import { cn } from './cn';

// Formulierveld: label + control + optionele hint/fout, met één gedeelde
// input-stijl. Voorheen droeg elk formulier zijn eigen
// `py-[10px] px-3 rounded-btn border border-line bg-surface-2 …`-string, en
// waren de labels vaak <label>-wrappers zonder htmlFor — wat werkt, maar alleen
// zolang de control er letterlijk in genest zit.
//
// De id wordt hier gegenereerd en gekoppeld, zodat een label ook naast zijn
// control kan staan en fouten via aria-describedby worden voorgelezen.

export const FIELD_CONTROL =
  'min-h-12 w-full rounded-md border border-line bg-surface-2 px-3 py-2.5 font-body text-[16px] text-ink ' +
  'outline-none transition-[border-color,background-color] duration-150 ' +
  'placeholder:text-ink-3 focus-visible:border-primary-500 focus-visible:bg-surface ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

export default function Field({ label, hint, error, children, className = '' }) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label
        htmlFor={id}
        className="font-condensed text-[13.5px] font-bold uppercase tracking-[0.06em] text-ink-2"
      >
        {label}
      </label>
      {children({ id, 'aria-describedby': describedBy, 'aria-invalid': error ? true : undefined })}
      {hint && !error && (
        <p id={hintId} className="text-[14px] text-ink-3">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="text-[14px] text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
